type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

/**
 * Vertical 3-dots ("more actions" / kebab) icon. Shared across Content Studio
 * clip cards and the Story Manager folder/story menus. Defaults to
 * `currentColor` so the surrounding button's `color` controls it.
 */
const MoreVertIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 24 24',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill={fillColor}>
      <circle cx="12" cy="5" r="2" />
      <circle cx="12" cy="12" r="2" />
      <circle cx="12" cy="19" r="2" />
    </svg>
  );
};

export default MoreVertIcon;
